<tt-page *ngIf="!!page">
    <tt-card>
        <tt-input ttLabel="bsp_name" [ttModel]="page.bsp_name" ttReadonly></tt-input>
        <tt-input ttLabel="subscription_name" [ttModel]="page.subscription_name" ttReadonly></tt-input>
        <tt-input ttLabel="usergroup_names" [ttModel]="page.usergroup_names" ttReadonly></tt-input>
        <tt-editor class="flex-1" ttLabel="html_description_base64" [(ttModel)]="page.html_description_base64" ttHeight="95vh"></tt-editor>
        <tt-checkbox ttLabel="equal_html_description_for_all" [(ttModel)]="page.equal_html_description_for_all"></tt-checkbox>
        <tt-button-save ttText="bspsub_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
